import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "./css/styles.css";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { muiAbtn, muiBbtn } from "./style";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
};

export default function AddSchools() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [newLink, setNewLink] = useState("");
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [diplomaticCountries, setDiplomaticCountries] = useState([]);

  const handleOpen = () => {
    setOpen(true);
    setNewLink("");
    setSelectedCountry(null);
  };

  const handleClose = () => {
    setOpen(false);
    setNewLink("");
    setSelectedCountry(null);
  };

  const getData = () => {
    setLoading(true);

    const q = query(collection(db, "countries"), orderBy("name", "asc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const updatedRows = [];
      const diplomaticRows = [];
      snapshot.forEach((document) => {
        const data = document.data();
        updatedRows.push(data);
        if (data.SchoolsLink) {
          diplomaticRows.push({ ...data, id: document.id });
        }
      });
      setCountries(updatedRows);
      setDiplomaticCountries(diplomaticRows);
      setLoading(false);
    });

    return unsubscribe;
  };

  useEffect(() => {
    let unsubscribe;
    let active = true;

    if (active) {
      unsubscribe = getData();
    }

    return () => {
      active = false;
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  useEffect(() => {
    if (!loading && countries.length < 0) {
      toast.error("Countries could not load!");
    }
  }, [loading, countries]);

  const handleSaveLink = async () => {
    if (selectedCountry && newLink) {
      try {
        const countryDoc = doc(db, "countries", selectedCountry.id);
        await updateDoc(countryDoc, {
            SchoolsLink: newLink,
        });
        toast.success("Schools Link added successfully!");
        handleClose();
      } catch (error) {
        toast.error("Failed to add the link.");
      }
    } else {
      toast.error("Please select a country and enter a link.");
    }
  };

  const handleEditLink = (country) => {
    setSelectedCountry(country);
    setNewLink(country.SchoolsLink || "");
    setOpen(true);
  };

  const handleDeleteLink = async (country) => {
    try {
      const countryDoc = doc(db, "countries", country.id);
      await updateDoc(countryDoc, {
        SchoolsLink: "",
      });
      toast.success("Schools Link removed successfully!");
    } catch (error) {
      toast.error("Failed to remove the link.");
    }
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          padding: 40,
          paddingRight: 20,
          backgroundColor: "#212C62",
        }}
      >
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <form>
              <Box style={{ display: "flex", justifyContent: "end" }}>
                <CloseIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer", color: "gray" }}
                />
              </Box>
              <h2 className="mb-4" style={{ color: "#212C62" }} mb={3}>
                {selectedCountry ? "Edit School List" : "Add New List"}
              </h2>

              <FormControl fullWidth size="small" className="mb-4">
                <InputLabel id="country-select-label">Select Country</InputLabel>
                <Select
                  labelId="country-select-label"
                  id="country-select"
                  value={selectedCountry ? selectedCountry.name : ""}
                  label="Select Country"
                  onChange={(e) => {
                    const selected = countries.find(
                      (country) => country.name === e.target.value
                    );
                    setSelectedCountry(selected);
                  }}
                  disabled={!!selectedCountry}
                >
                  {countries.map((country, index) => (
                    <MenuItem key={index} value={country.name}>
                      {country.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth size="small">
                <TextField
                  className="mb-4"
                  id="outlined-basic"
                  label="Enter Link"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={newLink}
                  onChange={(e) => setNewLink(e.target.value)}
                />
              </FormControl>

              <Button
                fullWidth
                className="mt-2 muibtn"
                variant="contained"
                color="primary"
                size="small"
                style={muiBbtn}
                onClick={handleSaveLink}
              >
                <>
                  <AddIcon style={{ marginRight: 10 }} />
                  {selectedCountry ? "Update Schools List" : "Add Schools List"}
                </>
              </Button>
            </form>
          </Box>
        </Modal>

        <Card style={{ padding: 50, borderRadius: 10 }}>
          <div className="row d-flex justify-content-between">
            <div className="col-6">
              <h1
                className="mb-4 py-4"
                style={{ textAlign: "left", color: "#212C62" }}
              >
                <b>Schools List Per Country</b>
              </h1>
              <Button
                variant="contained"
                color="primary"
                style={muiBbtn}
                size="small"
                onClick={handleOpen}
              >
                Add Schools
              </Button>
            </div>
          </div>

          <div>
            <h3 style={{ marginTop: 20, color: "#212C62" }}>
              Countries with Schools Links
            </h3>
            {diplomaticCountries.length > 0 ? (
              diplomaticCountries.map((country, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <span style={{ fontSize: 18 }}>{country.name}</span>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{ marginRight: 10 }}
                      onClick={() => handleEditLink(country)}
                    >
                      <EditIcon />
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => handleDeleteLink(country)}
                    >
                      <DeleteIcon />
                      Delete
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <p>No countries with Schools links.</p>
            )}
          </div>
        </Card>
      </div>
    </>
  );
}